<a *ngIf="isLive" class="nav-link no-wrap were-live" routerLink="/live">
  <img class="mr-2" height="24px" src="https://cdn.watchcorridor.com/assets/live.svg" />
  {{ 'were-live' | translate }}
</a>


<b *ngIf="!isLive && timeUntilLs">{{ (isMobileView ? '' : 'livemenu-were' | translate ) + ' ' + ('livemenu-livein' | translate)}} <span class="text-primary no-wrap">{{timeUntilLs}}</span></b>
